import styled from 'styled-components';
import { RichText } from '@atlassiansox/bxp-content-framework';
import { colorCSS } from '../../../../styles';
export const Root = styled.div `
  background-color: ${colorCSS('N20')};
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  width: 100%;
`;
export const LoginText = styled(RichText) `
  p {
    margin: 0;
  }
`;
//# sourceMappingURL=DetailsPanel.styles.js.map